module.exports = __webpack_public_path__ + "img/dj.1ae4c0f6.svg";